// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router/index.js'
import { i18n } from './i18n.js'

Vue.use(BootstrapVue)

Vue.config.productionTip = false
import axios from 'axios'
//import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
Vue.use(VueAxios, axios)
import Snotify from 'vue-snotify/vue-snotify.min.js'
Vue.use(Snotify)

import store from './store.js'
Vue.use(store)
Vue.prototype.$store = store
Vue.axios.defaults.baseURL = 'https://oldapi.expertspk.ru/api/'
Vue.axios.interceptors.response.use((response) => {
    return response
  }, (error) => {
    if (error.response.status == 403) {
      localStorage.removeItem('token')
      Vue.auth.logout({
        makeRequest: true,
        redirect: {name: 'Index'},
        success () {
          console.log('success ' + this.context)
        },
        error () {
          console.log('error ' + this.context)
        }
      })
    }
    if (error.response.status == 409) {
                               Vue.prototype.$snotify.error(error.response.data, {
                                    timeout: 1000,
                                    showProgressBar: true,
                                    closeOnClick: false,
                                    pauseOnHover: true,
                                    position: 'rightTop'
                                })
                                return false
    }
    if (error.response.status == 401) {
        router.push({ path: '/login' })
    }
    if (error.response.status == 302) {
        alert('Похоже что сервер сейчас недоступен. Попробуйте зайти позднее.')
    }
    return Promise.reject(error)
  })
Vue.axios.defaults.headers.common['lang'] = i18n.locale
import Meta from 'vue-meta'
Vue.use(Meta)



import Chat from 'vue-beautiful-chat'
Vue.use(Chat)

Vue.router = router
Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  authRedirect: {path: '/'},
  tokenStore: ['localStorage', 'cookie'],
})

  

import VueNativeSock from 'vue-native-websocket'

Vue.use(VueNativeSock, 'wss://api.expertspk.ru/wss', { reconnection: true, store: store })
//import VueSocketIO from 'vue-socket.io'
//Vue.use(new VueSocketIO({
//    debug: true,
//    connection: 'https://socket.sci-space.com/',
//    vuex: {
//        store,
//        actionPrefix: 'SOCKET_',
//        mutationPrefix: 'SOCKET_'
//    }
//}))
//import VueNativeSock from 'vue-native-websocket'
//Vue.use(VueNativeSock, 'wss://dev.sci-space.com/wss', { reconnection: true, store: store })
//import VueSocketio from 'vue-socket.io';
//Vue.use(VueSocketio, 'wss://dev.sci-space.com:8083');


//Нужно переопредлеить только в требуемые места
import VueHighcharts from 'vue-highcharts';

Vue.use(VueHighcharts);
//import {ClientTable} from 'vue-tables-2'
import {ServerTable} from 'vue-tables-2'

import SocialSharing from 'vue-social-sharing'
Vue.use(SocialSharing)
//Vue.use(ClientTable, {}, false, 'bootstrap4', 'default')
Vue.use(ServerTable, {}, false, 'bootstrap4', 'default')
//Конец переопределяемых компонентов



Vue.use(require('vue-chat-scroll'))


import moment from 'moment-timezone'
import 'moment/locale/ru'
Vue.use(require('vue-moment'), {
  moment
})



/* eslint-disable no-new */
new Vue({
  render: h => h(App),
  router:router,
  i18n: i18n,
  store: store,
  components: { App },
  watch: {
    $route () {
      store.state.open_room_id = null
      store.state.messages = []
    }
  },
  methods: {
    follow: function (userId) {
      this.$http.get('social/follow', {
        params: {
          userid: userId,
        }
      })
      .then(response => {
        if(response.data.com === 'add') {
          this.$auth.user().following.push(userId)
          if(this.$auth.user().followers.indexOf(userId) != -1)
          {
            this.$auth.user().friends.push(userId)
          }
        }
        if(response.data.com === 'remove') {
          this.$auth.user().following.splice(this.$auth.user().following.indexOf(userId), 1);
          this.$auth.user().friends.splice(this.$auth.user().friends.indexOf(userId), 1);
        }
        // JSON responses are automatically parsed.
      })
      .catch(e => {
        alert('Непредвиденная ошибка')
      })
    },
    toFavorite: function (object_id, type, name) {
      this.$http.get('user/to-favorite', {
        params: {
          object_id: object_id,
          type: type
        }
      })
      .then(response => {
        if(response.data === 'add') {
          this.$snotify.success('Добавлено в избранное', 'Добавлено', {
            timeout: 1000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            position: 'rightTop'
          })
        }
        if(response.data === 'remove') {
          this.$snotify.warning('Удалено из избранного', 'Удалено', {
            timeout: 1000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            position: 'rightTop'
          })
        }
        // JSON responses are automatically parsed.
      })
      .catch(e => {
        alert('Непредвиденная ошибка')
      })
    }
  }
}).$mount('#app')

